import React, { useEffect, useRef } from "react";
import "../styles/App.css";

// Спливаюче вікно про успішну дію (модальне): заголовок, рядки підсумку,
// кнопка «Добре». Закривається кнопкою, Escape або кліком по затемненню;
// фокус при відкритті -- на кнопці.
const SuccessDialog = ({ open, title, lines = [], note, onClose }) => {
  const buttonRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    buttonRef.current?.focus();
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="success-dialog-backdrop" onClick={onClose} data-testid="success-dialog-backdrop">
      <div
        className="success-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="success-dialog-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="success-dialog-icon" aria-hidden="true">
          ✓
        </div>
        <h3 id="success-dialog-title" className="success-dialog-title">
          {title}
        </h3>
        {lines.length > 0 && (
          <ul className="success-dialog-lines">
            {lines.map((line) => (
              <li key={line}>{line}</li>
            ))}
          </ul>
        )}
        {note && <p className="success-dialog-note">{note}</p>}
        <button ref={buttonRef} type="button" className="submit-button" onClick={onClose}>
          Добре
        </button>
      </div>
    </div>
  );
};

export default SuccessDialog;
